import { getSessionId, getSessionStartTime, clearIncompleteStep, getCurrentStep, saveCurrentStep, getAuthXToken } from '@/services/auth'
import { NR_REDIRECT_TO_PRODUCT, NR_LOGIN_STEP, NR_STEPS, EMAIL_DOMAIN_SITEMINDER } from './constants'

/**
 * Tracks successful redirect to product in New Relic and updates session state.
 * Records the completion of the login process and calculates total duration.
 */
export const nrRedirectToProduct = (): boolean => {
  try {

    const authxToken = getAuthXToken()

    if (authxToken.payload.email.includes(EMAIL_DOMAIN_SITEMINDER)) {
      return false
    }

    const sessionId = getSessionId()
    const sessionStartTime = getSessionStartTime()
    const step = getCurrentStep()

    const newrelic: any = (window as any).newrelic

    // Guard against invalid session start time
    if (!sessionStartTime || isNaN(Number(sessionStartTime))) {
      return false
    }

    const duration = Date.now() - Number(sessionStartTime)

    if (newrelic && sessionId && step) {
      newrelic.addPageAction(NR_LOGIN_STEP, { sessionId, success: true })
      newrelic.addPageAction(NR_REDIRECT_TO_PRODUCT, { sessionId, durationMs: duration })
      clearIncompleteStep()
      saveCurrentStep(NR_STEPS.REDIRECT_TO_PRODUCT)
      return true
    }

    return false
  } catch {
    return false
  }
}
